import { render } from "./EmptyCart.vue?vue&type=template&id=c2c27b40&scoped=true"
import script from "./EmptyCart.vue?vue&type=script&lang=js"
export * from "./EmptyCart.vue?vue&type=script&lang=js"

import "./EmptyCart.vue?vue&type=style&index=0&id=c2c27b40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c27b40"]])

export default __exports__